import {
  COMPANY_FILE_ERROR_REQUEST,
  COMPANY_FILE_RECEIVED_REQUEST,
  COMPANY_FILE_REQUEST,
  COMPANY_FILES_ERROR_REQUEST,
  COMPANY_FILES_RECEIVED_REQUEST,
  COMPANY_FILES_REQUEST,
} from "./types";

export const companyFiles = (
  state = {
    companyFiles: [],
    isFetchingCompanyFiles: false,
    companyFilesError: null,
  },
  action
) => {
  switch (action.type) {
    case COMPANY_FILES_REQUEST:
      return {
        ...state,
        isFetchingCompanyFiles: true,
      };
    case COMPANY_FILES_RECEIVED_REQUEST:
      return {
        ...state,
        isFetchingCompanyFiles: false,
        companyFiles: action.data.data,
      };
    case COMPANY_FILES_ERROR_REQUEST:
      return {
        ...state,
        isFetchingCompanyFiles: false,
        companyFilesError: action.error,
      };
    default:
      return state;
  }
};

export const companyFile = (
  state = {
    companyFile: [],
    isFetchingCompanyFile: false,
    companyFileError: null,
  },
  action
) => {
  switch (action.type) {
    case COMPANY_FILE_REQUEST:
      return {
        ...state,
        isFetchingCompanyFiles: true,
      };
    case COMPANY_FILE_RECEIVED_REQUEST:
      return {
        ...state,
        isFetchingCompanyFiles: false,
        companyFiles: action.data.data,
      };
    case COMPANY_FILE_ERROR_REQUEST:
      return {
        ...state,
        isFetchingCompanyFiles: false,
        companyFilesError: action.error,
      };
    default:
      return state;
  }
};
